// Tells the server while a tournament is open and visible on this device, so it does not also
// buzz the phone about your turn (see server/domain/presence.ts). Reports repeat every 20 s and
// expire on the server by themselves if the tab disappears without saying goodbye.
import { useEffect } from 'react';

const REPEAT_MS = 20_000;

function report(tournamentId: string, watching: boolean, closing = false): void {
  void fetch(`/api/tournaments/${tournamentId}/presence`, {
    method: 'PUT',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'kotipoker' },
    body: JSON.stringify({ watching }),
    // Delivered even while the page is closing (only then: browsers limit such requests).
    keepalive: closing,
  })
    // Read the (tiny) answer so the request completes instead of lingering as open.
    .then((res) => res.text())
    .catch(() => undefined);
}

export function useTournamentPresence(tournamentId: string | undefined): void {
  useEffect(() => {
    if (!tournamentId) return;
    let timer: number | undefined;
    const update = () => {
      window.clearInterval(timer);
      if (document.visibilityState === 'visible') {
        report(tournamentId, true);
        timer = window.setInterval(() => report(tournamentId, true), REPEAT_MS);
      } else report(tournamentId, false);
    };
    const leave = () => report(tournamentId, false, true);
    update();
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pagehide', leave);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', update);
      window.removeEventListener('pagehide', leave);
      leave();
    };
  }, [tournamentId]);
}
